import React from 'react'

import FormError from "../../../../../../../core/gd-form/common/form-error/form-error"
import FieldsFactory from "../../../../../../../core/fields3/fields-factory"
import {FieldType} from "../../../../../../../core/fields3/field-type"
import getViewLocationOptions from "../../../../../../../core/model2/custom-view/actions/get-view-location-options"
import FieldFormElement from "../../../../../../../core/fields3/render/form-elemnent"
import CustomView from "../../../../../../../core/model2/custom-view/custom-view"
import FormManager from "../../../../../../../core/gd-form/common/form-manager"
import FieldFormElementView from "../../../../../../../core/fields3/render/form-elemnent-view";

type Props = {
    view    : CustomView
    form    : FormManager
}

// const debug = "ViewLocation"
const debug = false

export default function ViewLocation(props: Props) {

    debug && console.log(debug, "view=", props.view)

    if (props.view.parentProjectId) {
        return (
            <div className="row">
                <div className="label">Display in:</div>
                <div className="element">
                    <FieldFormElementView field={gd.fields.project.parentId}
                                          model={{parentId: props.view.parentProjectId}}
                                          disabled={true}
                    />
                </div>
            </div>
        )
    }


    const field = FieldsFactory.get({
        fieldId         : 'location',
        type            : FieldType.DROPDOWN,
        options         : getViewLocationOptions(props.view.type),
        noValueOption   : false,
        showMenuMore    : false
    })

    return (
        <div className="row">
            <div className="label">Display in:</div>
            <div className="element">
                <FieldFormElement field={field} form={props.form}/>

                <FormError form={props.form} name="location" />
            </div>
        </div>
    )
}